import React, { useState, useEffect, useRef } from 'react';

const initials = (name) => {
  if (!name) return '?';
  const p = name.trim().split(' ');
  return p.length >= 2 ? (p[0][0]+p[1][0]).toUpperCase() : name.slice(0,2).toUpperCase();
};

const MenuItem = ({ icon, label, sub, onClick, danger }) => (
  <button
    onClick={onClick}
    style={{
      display:'flex', alignItems:'center', gap:11, width:'100%', padding:'8px 10px',
      borderRadius:6, border:'none', background:'transparent', cursor:'pointer',
      textAlign:'left', transition:'background 0.12s', fontFamily:'inherit',
    }}
    onMouseEnter={e => e.currentTarget.style.background = danger ? '#FEF6F6' : '#F5F5F5'}
    onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
  >
    <span style={{ color: danger ? '#B42318' : '#6B7280', flexShrink:0, display:'flex' }}>{icon}</span>
    <div style={{ flex:1, minWidth:0 }}>
      <div style={{ fontSize:13, fontWeight:400, color: danger ? '#B42318' : '#111' }}>{label}</div>
      {sub && <div style={{ fontSize:11.5, color:'#9CA3AF', marginTop:1 }}>{sub}</div>}
    </div>
  </button>
);

export default function ProfileMenu({ user, onNav, onLogout }) {
  const [open, setOpen]   = useState(false);
  // Misma llave que Settings.js (uKey): la foto se guarda por usuario
  const avKey = `talku_avatar_${user?.id || 'default'}`;
  const [avatar, setAvatar] = useState(() => localStorage.getItem(avKey) || '');
  const ref = useRef(null);

  useEffect(() => {
    const sync = () => setAvatar(localStorage.getItem(avKey) || '');
    sync();
    window.addEventListener('storage', sync);      // otra pestaña
    window.addEventListener('talku:avatar', sync); // esta pestaña (lo emite Settings al cambiar la foto)
    return () => { window.removeEventListener('storage', sync); window.removeEventListener('talku:avatar', sync); };
  }, [avKey]);

  // La foto vive en el servidor (/auth/avatar); localStorage es solo caché para mostrarla al instante.
  // Si el servidor no tiene y este navegador sí (foto subida antes del cambio), se sube una vez.
  useEffect(() => {
    let off = false;
    const H = { 'Authorization': `Bearer ${localStorage.getItem('talku_token') || ''}` };
    fetch('https://talku.online/auth/avatar', { headers: H }).then(r => (r.ok ? r.json() : null)).then(d => {
      if (off || !d) return;
      const local = localStorage.getItem(avKey) || '';
      if (d.avatar) {
        if (d.avatar !== local) { localStorage.setItem(avKey, d.avatar); window.dispatchEvent(new Event('talku:avatar')); }
      } else if (local.startsWith('data:image/') && local.length < 400000) {
        fetch('https://talku.online/auth/avatar', { method: 'PUT', headers: { ...H, 'Content-Type': 'application/json' }, body: JSON.stringify({ avatar: local }) }).catch(() => {});
      } else if (local) {
        localStorage.removeItem(avKey); window.dispatchEvent(new Event('talku:avatar'));
      }
    }).catch(() => {});
    return () => { off = true; };
  }, [avKey]);

  useEffect(() => {
    if (!open) return;
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, [open]);

  const go = (screen) => { setOpen(false); if (onNav) onNav(screen); };
  const logout = () => { setOpen(false); if (onLogout) onLogout(); };

  const AvatarImg = ({ size }) => (
    <div style={{
      width:size, height:size, borderRadius:'50%', background:'#F0F0F0',
      overflow:'hidden', flexShrink:0, display:'flex', alignItems:'center',
      justifyContent:'center', color:'#374151', fontSize:Math.round(size*0.38), fontWeight:500,
    }}>
      {avatar
        ? <img src={avatar} alt="" style={{ width:'100%', height:'100%', objectFit:'cover' }}/>
        : initials(user?.name)
      }
    </div>
  );

  return (
    <div ref={ref} style={{ position:'relative', flexShrink:0 }}>
      {/* Pill */}
      <style>{`
        .prf-btn{display:flex;align-items:center;gap:8px;background:#fff;border:1px solid #EFEFEF;border-radius:6px;padding:3px 9px 3px 3px;cursor:pointer;user-select:none;transition:background .15s,border-color .15s,transform .15s;animation:prf-in .3s ease .2s both;}
        .prf-btn:hover{background:#F7F7F7;border-color:#E5E7EB;transform:translateY(-1px);}
        .prf-btn:active{transform:scale(.97);}
        .prf-btn.is-open{background:#F3F3F3;border-color:#E5E7EB;}
        .prf-dd{animation:prf-dd .16s cubic-bezier(.4,0,.2,1) both;transform-origin:top right;}
        @keyframes prf-in{from{opacity:0}to{opacity:1}}
        @keyframes prf-dd{from{opacity:0;transform:translateY(-4px)}to{opacity:1;transform:none}}
        @media (max-width:600px){.prf-txt{display:none;}}
      `}</style>
      <div className={`prf-btn${open ? ' is-open' : ''}`} onClick={() => setOpen(o => !o)}>
        <AvatarImg size={26}/>
        <div className="prf-txt">
          <div style={{ fontSize:13, fontWeight:400, color:'#111', lineHeight:1.25 }}>
            {user?.name?.split(' ')[0] || 'Usuario'}
          </div>
          <div style={{ fontSize:11, color:'#9CA3AF', lineHeight:1.25 }}>{user?.role || 'Agente'}</div>
        </div>
        <svg
          width="14" height="14" viewBox="0 0 24 24" fill="none"
          stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
          style={{ marginLeft:2, transition:'transform 0.15s', transform: open ? 'rotate(180deg)' : 'none' }}
        >
          <polyline points="6 9 12 15 18 9"/>
        </svg>
      </div>

      {/* Dropdown */}
      {open && (
        <div className="prf-dd" style={{
          position:'absolute', top:'calc(100% + 8px)', right:0,
          background:'#fff', borderRadius:8, minWidth:240,
          boxShadow:'0 8px 24px rgba(0,0,0,0.08), 0 1px 3px rgba(0,0,0,0.04)',
          border:'1px solid #EFEFEF', padding:5, zIndex:9999,
        }}>
          {/* User header */}
          <div style={{ padding:'9px 10px 11px', borderBottom:'1px solid #F3F3F3', marginBottom:4 }}>
            <div style={{ display:'flex', alignItems:'center', gap:10 }}>
              <AvatarImg size={36}/>
              <div style={{ minWidth:0 }}>
                <div style={{ fontSize:13, fontWeight:500, color:'#111', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
                  {user?.name || '—'}
                </div>
                <div style={{ fontSize:11.5, color:'#9CA3AF', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
                  {user?.email || ''}
                </div>
                <div style={{ marginTop:5, display:'inline-block', padding:'1px 7px', borderRadius:4, fontSize:11, fontWeight:400,
                  background:'#F3F4F6', color:'#4B5563', border:'1px solid #EBEBEB',
                }}>
                  {user?.role || '—'}
                </div>
              </div>
            </div>
          </div>

          <MenuItem
            onClick={() => go('Configuraciones')}
            label="Mi perfil"
            sub="Foto, nombre y contraseña"
            icon={<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/></svg>}
          />
          <MenuItem
            onClick={() => go('Configuraciones')}
            label="Configuraciones"
            sub="Usuarios, canales y tiendas"
            icon={<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>}
          />

          <div style={{ height:1, background:'#F3F3F3', margin:'4px 0' }}/>

          <MenuItem
            onClick={logout}
            label="Cerrar sesión"
            danger
            icon={<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>}
          />
        </div>
      )}
    </div>
  );
}
